module.exports = __webpack_public_path__ + "media/src/admin/images/clock-face-baefa4bd38701ee9a9c1f16a4ac385c1.png";